import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthServiceService } from '../../../core/http/auth-service.service';
import { SettingsService } from '../../../core/http/settings.service';
import { UserComponent } from '../../../shared/components/user/user.component';
import { AlocatedSocModalComponent } from '../../components/alocated-soc-modal/alocated-soc-modal.component';
import { AppointmentComponent } from '../../components/appointment/appointment.component';
import { BanksModalComponent } from '../../components/banks-modal/banks-modal.component';
import { BranchModalComponent } from '../../components/branch-modal/branch-modal.component';
import { CardModalComponent } from '../../components/card-modal/card-modal.component';
import { CartegoryModalComponent } from '../../components/cartegory-modal/cartegory-modal.component';
import { CityModalComponent } from '../../components/city-modal/city-modal.component';
import { CompanyModalComponent } from '../../components/company-modal/company-modal.component';
import { CountryModalComponent } from '../../components/country-modal/country-modal.component';
import { CreateAppointmentComponent } from '../../components/create-appointment/create-appointment.component';
import { DepartmemtModalComponent } from '../../components/departmemt-modal/departmemt-modal.component';
import { DropDownComponent } from '../../components/drop-down/drop-down.component';
import { EmployeeModalComponent } from '../../components/employee-modal/employee-modal.component';
import { GroupsModalComponent } from '../../components/groups-modal/groups-modal.component';
import { ItemsModalComponent } from '../../components/items-modal/items-modal.component';
import { NationalModalComponent } from '../../components/national-modal/national-modal.component';
import { OfflineAppointmentComponent } from '../../components/offline-appointment/offline-appointment.component';
import { OpdDetailModalComponent } from '../../components/opd-detail-modal/opd-detail-modal.component';
import { OpdModalComponent } from '../../components/opd-modal/opd-modal.component';
import { RefDoctorModalComponent } from '../../components/ref-doctor-modal/ref-doctor-modal.component';
import { SalesCardModalComponent } from '../../components/sales-card-modal/sales-card-modal.component';
import { SetupModalComponent } from '../../components/setup-modal/setup-modal.component';
import { SocModalComponent } from '../../components/soc-modal/soc-modal.component';
import { SpecializationModalComponent } from '../../components/specialization-modal/specialization-modal.component';
import { StateModalComponent } from '../../components/state-modal/state-modal.component';
import { SubDepartmentModalComponent } from '../../components/sub-department-modal/sub-department-modal.component';
import { TitleModalComponent } from '../../components/title-modal/title-modal.component';
import { UomModalComponent } from '../../components/uom-modal/uom-modal.component';
import { VoucherModalComponent } from '../../components/voucher-modal/voucher-modal.component';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  data;
  role = localStorage.getItem('role');
  name = localStorage.getItem('username');
  constructor(
    private modal: ModalService,
    public router: Router,
    public setting: SettingsService,
    private _snackBar: MatSnackBar,
    public auth: AuthServiceService
  ) {}

  openVoucher() {
    this.modal.openModal(VoucherModalComponent, 'modal');
  }

  openUser() {
    this.modal.openModal(UserComponent, 'modal');
  }
  openTitle() {
    this.modal.openModal(TitleModalComponent, 'modal');
  }
  openCity() {
    this.modal.openModal(CityModalComponent, 'modal');
  }
  openCountry() {
    this.modal.openModal(CountryModalComponent, 'modal');
  }
  openState() {
    this.modal.openModal(StateModalComponent, 'modal');
  }
  openSub() {
    this.modal.openModal(SubDepartmentModalComponent, 'modal');
  }
  openDept() {
    this.modal.openModal(DepartmemtModalComponent, 'modal');
  }
  openBank() {
    this.modal.openModal(BanksModalComponent, 'modal');
  }
  openEmployee() {
    this.modal.openModal(EmployeeModalComponent, 'modal');
  }
  openCompany() {
    this.modal.openModal(CompanyModalComponent, 'modal');
  }
  openCategory() {
    this.modal.openModal(CartegoryModalComponent, 'modal');
  }
  openCard() {
    this.modal.openModal(CardModalComponent, 'modal');
  }
  openBranch() {
    this.modal.openModal(BranchModalComponent, 'modal');
  }
  openSpecial() {
    this.modal.openModal(SpecializationModalComponent, 'modal');
  }
  openSoc() {
    this.modal.openModal(SocModalComponent, 'modal');
  }
  openUom() {
    this.modal.openModal(UomModalComponent, 'modal');
  }
  openAloc() {
    this.modal.openModal(AlocatedSocModalComponent, 'modal');
  }
  openGroups() {
    this.modal.openModal(GroupsModalComponent, 'modal');
  }
  openItem() {
    this.modal.openModal(ItemsModalComponent, 'modal');
  }
  openOpd() {
    this.modal.openModal(OpdModalComponent, 'modal');
  }
  openNational() {
    this.modal.openModal(NationalModalComponent, 'modal');
  }
  openSale() {
    this.modal.openModal(SalesCardModalComponent, 'modal');
  }
  openDetail() {
    this.modal.openModal(OpdDetailModalComponent, 'modal');
  }
  openSetup() {
    this.modal.openModal(SetupModalComponent, 'modal');
  }
  openRefDr() {
    this.modal.openModal(RefDoctorModalComponent, 'modal');
  }
  opendrop() {
    this.modal.openModal(DropDownComponent, 'modal');
  }
  openPointment() {
    this.modal.openModal(AppointmentComponent, 'modal');
  }
  openLocalPointment() {
    this.modal.openModal(OfflineAppointmentComponent, 'modal');
  }
  bookApointment() {
    this.modal.openModal(CreateAppointmentComponent, 'modal');
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {}

  logout() {
    this.router.navigate(['/login']);
    if (
      this.role == 'self-service user' ||
      this.role == 'self-service consultant'
    ) {
      this.setting.logouonline().subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          console.log(this.data);

          if (this.data.success) {
            this.router.navigate(['/login']);
            localStorage.removeItem('token');
            localStorage.removeItem('id');
            localStorage.removeItem('name');
            this._snackBar.open(this.data.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this._snackBar.open('Error try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
    } else {
      this.setting.logout().subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          console.log(this.data);

          if (this.data.success) {
            this.router.navigate(['/login']);
            localStorage.removeItem('token');
            localStorage.removeItem('id');
            localStorage.removeItem('name');
            localStorage.clear();
            this._snackBar.open(this.data.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this._snackBar.open('Error try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
    }
  }
}
